
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCog as ObiCogElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cog.js';
 
 
 

 
 export const ObiCog = createComponent({
   react: React,
   tagName: 'obi-cog',
   elementClass: ObiCogElement,
   events: {
     
   }
  });
 
 